import { axios } from '@/utils/request'

const api = {
  order: '/order/OrderRemove',
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  orderType: '/basicdata/orderType',
  company: '/enterprise/management',
  accessory: '/stock/selectutils'
}
// 省
export function getselectAllProvince (parameter) {
  return axios({
    url: '/basicdata/province/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 市
export function getselectCityName (parameter) {
  return axios({
    url: '/basicdata/city/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 区
export function getselectAreaName (parameter) {
  return axios({
    url: '/basicdata/area/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 市场负责人
export function getmarketPrincipal (parameter) {
  return axios({
    url: 'system/user/findByDeptId/104',
    method: 'get',
    params: parameter,
  })
}

// 获取订单负责人
export function getfindByDeptId (parameter) {
  return axios({
    url: 'system/user/findByDeptId/103',
    method: 'get',
    params: parameter,
  })
}

// 查询型号
export function selectmodel (parameter) {
  return axios({
    url: api.accessory + '/selectmodel',
    method: 'get',
    params: parameter
  })
}

// 查询品牌
export function selectbrand (parameter) {
  return axios({
    url: api.accessory + '/selectbrand',
    method: 'get',
    params: parameter
  })
}

// 列表
export function list (parameter) {
  return axios({
    url: api.order + '/list',
    method: 'get',
    params: parameter
  })
}

// 恢复
export function recover (parameter) {
  return axios({
    url: api.order + '/recover',
    method: 'get',
    params: parameter
  })
}

// 省市区下拉
export function getSelectAllProvince (parameter) {
  return axios({
    url: api.province + '/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectCityName  (parameter) {
  return axios({
    url: api.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectAreaName (parameter) {
  return axios({
    url: api.area + '/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单类型下拉
export function getOrderTypeList (parameter) {
  return axios({
    url: api.orderType + `/getList/${parameter}`,
    method: 'get',
  })
}
// 企业下拉框
export function getSlectCombox (parameter) {
  return axios({
    url: api.company + '/selectCombox',
    method: 'get',
    params: parameter
  })
}
// 订单负责人
export function findByDeptId (parameter) {
  return axios({
    url: `/system/user/findByDeptId/${103}`,
    method: 'get',
    params: parameter
  })
}